import { render, staticRenderFns } from "./dailysum-kr.vue?vue&type=template&id=33c94a9c&scoped=true&"
import script from "./dailysum-kr.vue?vue&type=script&lang=js&"
export * from "./dailysum-kr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c94a9c",
  null
  
)

export default component.exports